import { SHOP_DETAIL_ACTION, SHOP_DETAIL_ACTION_LOADER, SHOP_DETAIL_RESET } from "../type"

const initialState = {
  data: null,
  loader: false,
  error: null,
};
const detailReducer = (state = initialState, action) => {
  switch (action.type) {
    // loader:true on reset drives ShopDetail's "Loading product details" state.
    case SHOP_DETAIL_RESET: return { ...state, data: null, loader: true, error: null, };
    case SHOP_DETAIL_ACTION_LOADER:
      return { ...state, loader: action.loader };

    case SHOP_DETAIL_ACTION:
      return {
        ...state,
        data: action.data || null,
        loader: false,
        error: action.error || null,
      };

    default:
      return state;
  }
};

export default detailReducer;
